// Devises qui n'acceptent pas les montants décimaux (pas de centimes).
// Ajouter ici toute nouvelle devise sans décimales.
export const NO_DECIMAL_CURRENCIES: ReadonlySet<string> = new Set([
  "XAF", // Franc CFA BEAC
  "XOF", // Franc CFA BCEAO
  "KMF", // Franc comorien
  "GNF", // Franc guinéen
  "BIF", // Franc burundais
  "DJF", // Franc djiboutien
  "GWP", // Peso de Guinée-Bissau
  "MGA", // Ariary malgache
  "RWF", // Franc rwandais
  "VUV", // Vatu du Vanuatu
  "JPY", // Yen japonais
  "KRW", // Won coréen
  "PYG", // Guaraní paraguayen
  "UGX", // Shilling ougandais
  "CLP", // Peso chilien
  "IDR", // Roupie indonésienne
  "ISK", // Couronne islandaise
]);

export const isNoDecimalCurrency = (currency: string): boolean =>
  NO_DECIMAL_CURRENCIES.has(currency.trim().toUpperCase());
